import React from 'react';
import { TablePagination, useTheme, useMediaQuery } from '@mui/material';

/**
 * Bottom pagination bar shared by every Reports tab.
 *
 * Pinned below the scroll area by `flexShrink: 0`, so it must be a direct
 * child of the same flex column as ReportTabLayout's scrolling section.
 * Renders nothing when there are no rows.
 */
const ReportsPagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50, 100],
  show = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!show) return null;

  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      labelRowsPerPage={isMobile ? "Rows" : "Rows per page"}
      sx={{
        flexShrink: 0,
        width: '100%',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
        '& .MuiToolbar-root': {
          minHeight: '40px',
          px: 1
        },
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
          margin: 0,
          fontSize: '0.8rem'
        }
      }}
    />
  );
};

export default ReportsPagination;
